import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import { font } from '@styles/vars/font.style'
import { mq } from '@styles/vars/media-queries.style'
import styled from 'styled-components'

export const QuoteMain = styled.div`
  background-color: ${props => (props.bgColor ? props.bgColor : colors.mist)};
  color: ${props => (props.textColor ? props.textColor : colors.charcoal)};
  transition: height .25s ease;
`

export const QuoteFooter = styled.blockquote`
  display: grid;
  grid-template: 1fr / 1fr;
  justify-content: start;
`

export const QuoteCarouselItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  grid-column: 1;
  grid-row: 1;

  ${mq.desk} {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
  }
`
export const QuoteItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  ${mq.desk} {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
  }
`

export const QuoteText = styled.div`
  .quoteContent p:after {
    content: '”';
  }
  p {
    font-size: 22px;
  }
`

export const QuoteSign = styled.span`
  font-size: 100px;
  font-family: ${font.sans.family};
  font-weight: ${font.sans.weight.extrabold};
  display: block;
  line-height: 30px;
`

export const AutherDesc = styled.span`
  display: block;
  margin-bottom: 18px;
`

export const QuoteColumn = styled.footer`
  text-align: right;

  ${mq.deskMax} {
    margin-top: 8rem;
  }
`

export const QuoteAuthor = styled.p`
  font-family: ${font.sans.family};
  font-weight: ${font.sans.weight.extrabold};
  ${clamp('font-size', 18, 22)}
  line-height: 1.2;
`

export const QuoteRole = styled.p`
  font-family: ${font.sans.family};
  font-weight: ${font.sans.weight.regular};
  ${clamp('font-size', 16, 22)}
  line-height: 1.2;
  margin-left: auto;
`
